/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioWaveIcon24Regular = forwardRef('MediaAudioWaveIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.75 3.5a.75.75 0 1 0-1.5 0v17a.75.75 0 1 0 1.5 0v-17Z" }),
        React.createElement("path", { d: "M18.75 6.5a.75.75 0 1 0-1.5 0v11a.75.75 0 0 0 1.5 0v-11Z" }),
        React.createElement("path", { d: "M22.75 10a.75.75 0 1 0-1.5 0v4a.75.75 0 0 0 1.5 0v-4Z" }),
        React.createElement("path", { d: "M14 8a.75.75 0 0 1 .75.75v6.5a.75.75 0 1 1-1.5 0v-6.5A.75.75 0 0 1 14 8Z" }),
        React.createElement("path", { d: "M6 6.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V7A.75.75 0 0 1 6 6.25Z" }),
        React.createElement("path", { d: "M2.75 10.5a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0v-3Z" })));
});
